import Modal, { ModalProps } from './modal';

export type { ModalProps };
export default Modal;
